import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {GoogleOAuthProvider} from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <GoogleOAuthProvider clientId="548915747999-a4of61gvuniip3lhggp88ivnn2sj2ktc.apps.googleusercontent.com">
        <App/>
    </GoogleOAuthProvider>

);

